import React from 'react';
import {
  BorderWrapper,
  FlexRow,
  CategoryLabel,
  SectionHeader,
} from 'components/styled-components';
import { NumericInput, Switch } from '@blueprintjs/core';
import ErrorWrapper from 'components/forms/components/error-wrapper';

export const AnswerDetails = ({
  score,
  autoFail,
  handleScoreChange,
  handleAutoFailChange,
  scoreError,
}) => (
  <BorderWrapper padding="1rem">
    <SectionHeader>Details</SectionHeader>
    <FlexRow width="80%" justify="flex-start">
      <div style={{ width: '45%', marginRight: '3rem' }}>
        <CategoryLabel>Auto Fail</CategoryLabel>
        <Switch
          large={true}
          checked={autoFail}
          onChange={handleAutoFailChange}
        />
      </div>
      <div style={{ marginRight: '3rem' }}>
        {scoreError && (
          <ErrorWrapper>The score field cannot be blank.</ErrorWrapper>
        )}
        <CategoryLabel>Score</CategoryLabel>
        <NumericInput value={score} onValueChange={handleScoreChange} min={1} />
      </div>
    </FlexRow>
  </BorderWrapper>
);
